const NS = 'VideoArticleListBlock';
const CLS = 'videoArticleListBlock';

import { handleListFilters } from '../../../../global/js/listsFilter';

export class VideoArticleListBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.pageSize = 3; // zero-indexed
		this.listItems = this.$element.find(`.${CLS}-item`);
		this.loadMoreButton = this.$element.find(`.load-more`);
		this.emptyResultText = this.$element.find(`.${CLS}-emptyResult`);
		// handles two filter names only atm (dates/topics), might be improved to be dynamic if needed
		this.filters = this.$element.find(`.${CLS}-filters select`);
		this.clearButton = this.$element.find(`.${CLS}-btnClearWrap button`);
		this.itemClassName = '.videoArticleBlock';
		handleListFilters(this);
	}
}
